import gql from 'graphql-tag';

export const queryForControllerNotes = gql`
  query queryForControllerNotes(
    $limit: Int
    $page: Int
    $query: ControllerNoteSortOrQuery
    $sort: ControllerNoteSortOrQuery
  ) {
    queryForControllerNotes(
      limit: $limit
      page: $page
      query: $query
      sort: $sort
    ) {
      items {
        category
        AORId
        AORName
        addToTurnover
        abnormalOperation
        businessUnits
        callerFirstName
        callerLastName
        city
        contactId
        contactName
        createdAt
        county
        createdBy
        facilityName
        facilityId
        facilityUID
        falseAlarm
        id
        maop
        noteType
        phoneNumber
        pipeline
        pipelineSection
        state
        township
        updatedAt
        updater
        systemName
        entries {
          createdAt
          createdBy
          id
          note
          time
          updatedAt
          updater
          version
          controllerNotesId
          user
        }
        calloutInitiated
        unit
        unitStatus {
          id
          name
        }
        maintenance
        facilityScadaId
        valvePosition {
          id
          name
        }
        SCADAControl {
          id
          name
        }
      }
      totalRecords
    }
  }
`;
